export const BADGES_LIST_STRINGS = {
  title: 'Badges List',
  buttonBack: 'Back to home',
};
